import { model as i18n } from '!/i18n'
import { api } from '@setplex/tria-api'
import { combine, type Store } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { formatVodBundleInfoToUi } from './lib'

export const $vodBundlesRowFormatted = combine(
  api.vodBundles.$vodBundlesRow,
  ssePurchasesModel.$vodSet,
  i18n.$t,
  (vodBundles, adjust, { t }) =>
    vodBundles.map(formatVodBundleInfoToUi(t, adjust))
)

export const $vodBundlesRowTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('extras')
)
